// client/src/utils/imageValidation.js — Maxula
// Validation des images de deal AVANT upload (taille + dimensions) afin
// d'economiser les ressources serveur (l'image n'est jamais envoyee si invalide).

export const MAX_IMAGE_SIZE_MB = 2;            // taille max par image
export const MAX_IMAGE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export const MAX_IMAGE_DIMENSION = 2000;       // largeur ET hauteur max (px)

// Valide une image. Renvoie Promise<{ ok, reason?, width?, height? }>.
export function validateImageFile(file, { maxBytes = MAX_IMAGE_BYTES, maxDim = MAX_IMAGE_DIMENSION } = {}) {
  return new Promise((resolve) => {
    if (!file || !file.type || !file.type.startsWith('image/')) {
      resolve({ ok: false, reason: 'fichier non image' });
      return;
    }
    if (file.size > maxBytes) {
      resolve({ ok: false, reason: `trop lourd (${(file.size / 1048576).toFixed(1)} Mo > ${(maxBytes / 1048576).toFixed(0)} Mo)` });
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      try { URL.revokeObjectURL(url); } catch (e) {}
      if (w > maxDim || h > maxDim) {
        resolve({ ok: false, reason: `dimensions trop grandes (${w}x${h}px, max ${maxDim}px)` });
      } else {
        resolve({ ok: true, width: w, height: h });
      }
    };
    img.onerror = () => { try { URL.revokeObjectURL(url); } catch (e) {} resolve({ ok: false, reason: 'image illisible' }); };
    img.src = url;
  });
}

// Valide une liste de fichiers. Renvoie { valid: File[], rejected: [{name, reason}] }.
export async function validateImageFiles(files, opts) {
  const valid = [];
  const rejected = [];
  for (const f of files) {
    // eslint-disable-next-line no-await-in-loop
    const r = await validateImageFile(f, opts);
    if (r.ok) valid.push(f);
    else rejected.push({ name: f.name || 'image', reason: r.reason });
  }
  return { valid, rejected };
}
